export default __webpack_public_path__ + "static/media/tc-waklthrough-bg.080b105d.svg";